var _a;
import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
import { passwordSchema } from './common';
import { createAuthFormHook } from './createAuthFormHook';
export var ERegisterWithEmailFormField;
(function (ERegisterWithEmailFormField) {
    ERegisterWithEmailFormField["EMAIL"] = "email";
    ERegisterWithEmailFormField["PASSWORD"] = "password";
    ERegisterWithEmailFormField["REPEAT_PASSWORD"] = "repeatPassword";
})(ERegisterWithEmailFormField || (ERegisterWithEmailFormField = {}));
var required = fieldValidationMessageIds.required, invalidEmail = fieldValidationMessageIds.invalidEmail, passwordEntriesDoNotMatch = fieldValidationMessageIds.passwordEntriesDoNotMatch;
export var registerWithEmailFormSchema = yup.object((_a = {},
    _a[ERegisterWithEmailFormField.EMAIL] = yup
        .string()
        .required(required)
        .email(invalidEmail),
    _a[ERegisterWithEmailFormField.PASSWORD] = passwordSchema,
    _a[ERegisterWithEmailFormField.REPEAT_PASSWORD] = yup
        .string()
        .required(required)
        .oneOf([yup.ref(ERegisterWithEmailFormField.PASSWORD), ''], passwordEntriesDoNotMatch),
    _a));
export var useRegisterWithEmailForm = createAuthFormHook(registerWithEmailFormSchema);
